import BaseNormalizer from "./BaseNormalizer";

const merchantStoresNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "name",
  "shippingAddress.city",
  "shippingAddress.postalCode",
  "shippingAddress.recipientAddition",
  "shippingAddress.recipientName",
  "shippingAddress.street",
  "merchantAccounts.region",
]);

export default merchantStoresNormalizer;
